import React from "react";
import styles from "./scrollable-table.module.scss";
import {TableHeader} from "../table/table-header";
import {TableRow} from "../table/table-row";
import classNames from "classnames"
import {ScrollableTableHeaderCell} from "./scrollable-table-header-cell";

export const ScrollableTableHeaders = ({groupTitle, headers, shouldRenderEmptyRow, useShortName, className}) => {

  if (!headers || headers.length < 1) {
    return null;
  }

  return (<TableRow className={classNames(styles.table_header)}>
    <TableHeader className={classNames(styles.transparent_cell)}/>
    <TableHeader className={classNames(styles.group_title, styles.first_cell, className)}>{groupTitle}</TableHeader>
    <TableHeader className={classNames(styles.competitor_name)}/>
    <ScrollableTableHeaderCell headers={headers} shouldRenderEmptyRow={shouldRenderEmptyRow} useShortName={useShortName}/>
  </TableRow>)
};
